import { HeaderLogo } from 'ui/components/templates/Header';
import { ProgressSteps } from 'ui/components/templates/ProgressSteps';
import { FloraButton, styled } from '@grupoboticario/flora-react';

export const HeaderCheckout = {
  Button: styled(FloraButton, {
    '&[data-header-checkout-button="true"]': {
      background: 'transparent',
      color: '$nonPrimaryButtonContent',
      gridColumn: '2 / span 2',
      gridGap: '$3',
      justifySelf: 'end',

      '@tablet': {
        gridColumn: 'auto / span 1',
        order: 3,
      },

      '&:hover': {
        background: 'transparent',
        color: '$nonPrimaryButtonContent',
      },
    },
  }),

  LogoButton: styled(FloraButton, {
    '&[data-checkout-logo-button="true"]': {
      backgroundColor: 'transparent',
      border: 0,
      cursor: 'pointer',
      height: '$6',
      justifySelf: 'start',
      alignItems: 'baseline',
      padding: 0,

      '@tablet': {
        height: '$8',
        order: 1,
      },

      '&:hover': {
        backgroundColor: 'transparent',
      },
    },
  }),

  Logo: styled(HeaderLogo, {
    height: '$6',
    justifySelf: 'start',
    '@tablet': {
      height: '$8',
      order: 1,
    },
  }),

  Steps: styled(ProgressSteps, {
    justifySelf: 'center',
    gridColumn: 'auto / span 3',

    '@tablet': {
      gridColumn: 'auto / span 1',
      order: 2,
    },
  }),
};
